import React, {memo} from 'react';
import DatePicker, {ReactDatePickerProps} from 'react-datepicker';
import moment from '~/services/moment';
import 'react-datepicker/dist/react-datepicker.css';
import {isString} from 'lodash';

interface Props extends Omit<ReactDatePickerProps, 'selected' | 'startDate' | 'onChange'> {
  selected?: moment.MomentInput;
  onChange?: (value: Date) => void;
  showTimeSelect?: boolean;
  selectsRange?: boolean;
  onChangeDateRange?: (value: Date[]) => void;
  startDate?: Date | string;
  endDate?: Date;
  isModal?: boolean;
  placeholderText?: string;
  isDisabled?: boolean;
  showTimeSelectOnly?: boolean;
  timeFormat?: string;

  [key: string]: any;
}

export const AppDatePicker = memo(function AppDatePicker({
  selected,
  onChange,
  showTimeSelect,
  selectsRange,
  onChangeDateRange,
  startDate,
  endDate,
  isModal,
  placeholderText,
  isDisabled,
  showTimeSelectOnly,
  timeFormat,
  ...rest
}: Props) {
  const selectedDate = selected ? moment(selected).toDate() : undefined;

  const onChangeLocal = (value: any) => {
    if (!selectsRange && !!onChange) {
      onChange(value);
    } else if (!!selectsRange && !!onChangeDateRange) {
      let dateRange = [...value];
      if (dateRange[1]) {
        dateRange[1] = moment(dateRange[1]).add(23.99, 'hours').toDate();
      }
      onChangeDateRange(dateRange);
    }
  };

  let dateFormat = 'yyyy/MM/dd';

  if (showTimeSelect) {
    dateFormat = 'yyyy/MM/dd HH:mm:ss';
  }

  return (
    <DatePicker
      showTimeSelect={showTimeSelect}
      dateFormat={dateFormat}
      selected={selectedDate}
      onChange={onChangeLocal}
      selectsRange={selectsRange}
      startDate={isString(startDate) ? new Date(startDate) : startDate}
      endDate={isString(endDate) ? new Date(endDate) : endDate}
      withPortal={isModal}
      placeholderText={placeholderText}
      disabled={!!isDisabled}
      showTimeSelectOnly={showTimeSelectOnly}
      timeFormat={timeFormat}
      calendarStartDay={1}
      todayButton={'Today'}
      {...rest}
    />
  );
});
